function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0,
  y1: 0,
  x2: "100%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00baff",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007cff",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Delivery:-Coleta-v0",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "coleta/-lista-de-pacotes/-confirma\\xE7\\xE3o",
  transform: "translate(-157.000000, -377.000000)",
  fill: "url(#linearGradient-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 350.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons-/-material-ui-/-warning-outline",
  transform: "translate(150.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "error_outline-24px",
  transform: "translate(7.500000, 7.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.5 11.25C23.7375 11.25 24.75 12.2625 24.75 13.5v9C24.75 23.7375 23.7375 24.75 22.5 24.75 21.2625 24.75 20.25 23.7375 20.25 22.5v-9C20.25 12.2625 21.2625 11.25 22.5 11.25zM22.4775.0C10.0575.0.0 10.08.0 22.5.0 34.92 10.0575 45 22.4775 45 34.92 45 45 34.92 45 22.5 45 10.08 34.92.0 22.4775.0zM22.5 40.5c-9.945.0-18-8.055-18-18 0-9.945 8.055-18 18-18 9.945.0 18 8.055 18 18 0 9.945-8.055 18-18 18zm0-6.75C21.2573593 33.75 20.25 32.7426407 20.25 31.5 20.25 30.2573593 21.2573593 29.25 22.5 29.25 23.7426407 29.25 24.75 30.2573593 24.75 31.5 24.75 32.7426407 23.7426407 33.75 22.5 33.75z",
  id: "Shape"
}))))));

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / action / wifi-off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4d6b474a.svg";
export { ForwardRef as ReactComponent };